<template>
  <div id="contact-view">

    <!-- CONTENT -->

    <div id="wideContent">

      <div class="box">
        <div class="boxContent">

          <h1>Kontakt</h1>

          <p>
            <strong>Lenka Holubová</strong><br /> IČ: 49233629<br />
            Tel.: +420 723 222 400<br /> E-mail: holubova@salonjaja.cz<br />
            Adresa: Pražského 662, Praha 5 - Hlubočepy (vchod z boku
            domu)
          </p>

          <p>
            <b>Stříhání dle telefonické domluvy.</b>
          </p>

          <p style="text-align: center;">
            <router-link to="/about">
              <img width="470px" style="margin: 0" src="../../../static/photos/contact/vchod.jpg"/>
            </router-link>
          </p>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

      <div class="box">
        <div class="boxContent">
          <iframe width="100%" height="500" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=cs&amp;geocode=&amp;q=Salon+J%C3%A1ja&amp;aq=&amp;sll=50.035564,14.380422&amp;sspn=0.003042,0.008256&amp;ie=UTF8&amp;hq=Salon+J%C3%A1ja&amp;hnear=&amp;t=m&amp;cid=14801085705193409773&amp;z=14&amp;iwloc=A&amp;output=embed"></iframe>
        </div>

        <div class="cleaner">
          <!-- / -->
        </div>

      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

    <!-- /CONTENT -->

  </div>
</template>

<script>
  export default {
    name: 'contact-view',
    head: {
      title: { inner: 'Psí Salon Jája', separator: '-', complement: 'kde nás najdete a jak se s námi spojit' },
      meta: [
        { id: 'description', content: 'Náš salon se nachází na adrese Pražského 662, Praha 5 - Barrandov. Kontaktovat nás můžete na tel. čísle 723 222 400 nebo emailem holubova@salonjaja.cz' },
        { id: 'keywords', content: 'kontakt, mail, telefon, adresa, mapa' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// ContactView.vue?4ae23854